import * as React from 'react';
import {useDataProvider} from '../../fetchApi/dataProvider';
import {FETCH} from '../../fetchApi/types';
import {accessTokenLocalStorageKey, endpointEmailVerification, resourceCustomUsers} from '../../constants';
import {NotificationManager} from 'react-notifications';
import storage from '../../fetchApi/storage';
import {useTranslation} from 'react-i18next';
import {RouteChildrenProps} from 'react-router-dom';
import queryString from 'query-string';
import CallbackSpinner from '../Callback/CallbackSpinner';

const EmailVerification: React.FunctionComponent<RouteChildrenProps> = ({
    history,
    location
}) => {
    const {dataProvider} = useDataProvider();
    const {t: translate} = useTranslation();

    React.useEffect(() => {
        const queryParams = queryString.parse(location.search);

        dataProvider(FETCH, `${resourceCustomUsers}/${endpointEmailVerification}`, {
            token: queryParams.state,
        })
            .then(data => {
                const accessToken = data.data;
                storage.save(accessTokenLocalStorageKey, accessToken);

                NotificationManager.success(translate('users.actions.email_verified'));
            })
            .catch(e => {
                NotificationManager.error(e.message || e);
            })
            .finally(() => {
                history.push('/');
            });
    }, []);

    return (
        <CallbackSpinner />
    );
};

export default EmailVerification;